const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/ui.ts';
import { Action } from 'redux';

export const ACTION_TYPE_DASHBOARD_LOADED = 'DASHBOARD_LOADED';
export const ACTION_TYPE_PATAPP_MAINNAV_COLLAPSE = 'PATAPP_COLLAPSE_MAINNAV';
export const ACTION_TYPE_PATAPP_MAINNAV_EXPAND = 'PATAPP_EXPAND_MAINNAV';

export const PATAPP_ADD_SNACKBAR = 'PATAPP_ADD_SNACKBAR';
export const PATAPP_REMOVE_SNACKBAR = 'PATAPP_REMOVE_SNACKBAR';
export const PATAPP_REMOVE_ALERT = 'PATAPP_REMOVE_ALERT';

export const ACTION_TYPE_INVITATION_CODE = 'PATAPP_INVITATION_CODE';

export interface ICollapseMainNavAction extends Action {}

export function collapseMainNav(): ICollapseMainNavAction {
    return { type: ACTION_TYPE_PATAPP_MAINNAV_COLLAPSE };
}

export interface IExpandMainNavAction extends Action {}

export function expandMainNav(): IExpandMainNavAction {
    return { type: ACTION_TYPE_PATAPP_MAINNAV_EXPAND };
}

export function setDashboardLoaded() {
    return { type: ACTION_TYPE_DASHBOARD_LOADED };
}

export type InvitationCodeAction = {
    type: string;
    payload: { invitationCode: string };
};

export function storeInvitationCode(invitationCode: string): InvitationCodeAction {
    return {
        type: ACTION_TYPE_INVITATION_CODE,
        payload: {
            invitationCode,
        },
    };
}
